/**
 * Created by Jerker Nord on 2016-04-13.
 * Refactored by Ning Jiang on 2016-12-6.
 */

import {  ReelEngine } from "@nolimitcity/slot-game/bin/core/engines/reel/engine/ReelEngine";
import { Timeline, TweenLite, TimelineMax, Bounce, Ease, Back } from "gsap";

export interface IExpandingConfig extends IExpandAnimateConfig {
    reelID:number[],
}

export interface IExpandAnimateConfig {
    shrink:     boolean;
    targetSym:  number;

    type:number;
    
    duration?:  number;
    ease?:      any;
}

export class SanEnginePlayer extends ReelEngine {

    public Start():Timeline{
        return super.Start();
    }

    public Step():Timeline{
        return super.Step();
    }
    
    public Stop2(quickStop:boolean, duration:number ):Timeline {

        const distance:number = -(this.stepDistance * this.Steps);
        this.duration = quickStop ? this.configDuration.QUICK_STOP : duration;
        let ease:any = quickStop ? this.configEase.QUICK_STOP : this.configEase.STOP;

        const stopTl:TimelineMax = new TimelineMax({ 
            paused:true,
            onComplete:() =>  this.onSpinStopCompleted(),
        });
        
        stopTl.add(() => this.yPos = distance);

        stopTl.to(this, this.duration, {
            ease : ease,
            yPos : 0,
        });

        stopTl.add(() => this.callbacks.onStopCallback(),this.duration*0.7);
        stopTl.add(() => this.onBounce(),this.duration*0.85);

        // Remove if we have created an normal stop first.
        this.nextTimeline = null;
        this.nextTimeline = stopTl;
        return this.nextTimeline;
    }

    public expandingTL:TimelineMax;

    public ExpandSymbol(conf:IExpandAnimateConfig):Timeline{ 

        /*
        * Calculation heaven for defining Size ratio for correct positioning and scaling depending on config.
        */
    
        let totalAmountOfSymbols:number = this.Config.WINDOW_AMOUNT;

        let duration:number = (conf.duration != undefined ? conf.duration : this.configDuration.EXPAND)!;
        let easeCurve:any = (conf.ease != undefined ? conf.ease : this.configEase.EXPAND)!;

        /*
        * -------------------------------------------------------------------------------------------------------
        */

        // Time to loop threw the symbols on the reel and give them the configData depending on their current positions.
        let Tweens:TweenLite[] = [];
        this.expandingTL = new TimelineMax({
            paused:true,
            onComplete: () => { 
                this.callbacks.onCompletedExpanding ? this.callbacks.onCompletedExpanding() : null;
                // this.expandingTL = null!;
             }
        });

        let newSmallSize:number = this.Config.STEP_DISTANCE*0.5;
        let newLargeSize:number = this.Config.STEP_DISTANCE;

        let sizeTarget:number = conf.shrink ? newSmallSize : newLargeSize;

        let posOnBott:boolean = conf.targetSym > 0;
        let accPosition:number = 0;

        if(posOnBott){
            accPosition = conf.shrink ? newLargeSize + newSmallSize*0.5 : 0;
        }else{
            accPosition = conf.shrink ? -sizeTarget*0.5 : 0 ;
        }

        for(let pos = 0; pos < totalAmountOfSymbols; pos++){
            
            let posID:number = pos + this.Config.RESULT_OVERFLOW;
            let sym:PIXI.Sprite = this._animateContainer.children[posID] as PIXI.Sprite;

            let fromPosY:number = sym.position.y;
            if(duration == 0) sym.position.y = accPosition;
            else
                Tweens.push(TweenLite.fromTo(sym.position, duration, { y:fromPosY}, {
                    y : accPosition,
                    ease: easeCurve
                }));
            accPosition += sizeTarget;
        }
        
        this.expandingTL.add(Tweens);

        return this.expandingTL;
    }

    public playExpanding():void{
        this.expandingTL.play();
    }

    public StopTeaser(top:boolean):Timeline {

        const distance:number = -(this.stepDistance * this.Steps);

        const stopTl:TimelineMax = new TimelineMax({ 
            paused:true,
            onComplete:() =>  this.onSpinStopCompleted()
        });
        stopTl.add(() => this.yPos = distance);

        this.duration = this.configDuration.STOP*3;

        let ease:any = this.configEase.STOP;
        const tt:number = (top ? -this.stepDistance : this.stepDistance)*0.5;
        stopTl.to(this, this.duration, {
            ease : Back.easeOut,
            yPos : tt,
        });

        stopTl.add(() => this.callbacks.onStopCallback(),0);
        stopTl.add(() => this.onBounce(),this.duration*0.95 );

        stopTl.to(this, 0.4, {
            ease : Bounce.easeOut,// SlowMo.ease.config(0.7,0.7,false),
            yPos: 0},
        "+=0.3");

        // Remove if we have created an normal stop first.
        this.nextTimeline = null;
        this.nextTimeline = stopTl;
        return this.nextTimeline;
    }

    public StopTeaser2():Timeline {

        const distance:number = -(this.stepDistance * this.Steps);

        const stopTl:TimelineMax = new TimelineMax({ 
            paused:true,
            onComplete:() =>  this.onSpinStopCompleted()
        });
        stopTl.add(() => this.yPos = distance);
        stopTl.add(() => this.callbacks.onStopCallback(),0);
        this.duration = this.configDuration.STOP*2.5;
        
        // const tt:number = (Math.random() > 0.5 ? -this.stepDistance : this.stepDistance)*0.45;
        const tt:number = -this.stepDistance*0.7;
        stopTl.to(this, this.duration, {
            ease : Back.easeOut.config(2.2),
            yPos : tt,
        });

        stopTl.add(() => this.onBounce(), "-=" + this.duration*0.6);

        stopTl.to(this, 0.25, {
            ease : Bounce.easeOut,// SlowMo.ease.config(0.7,0.7,false),
            yPos: 0});

        

        // Remove if we have created an normal stop first.
        this.nextTimeline = null;
        this.nextTimeline = stopTl;
        return this.nextTimeline;
    }

    // public StopTeaser():Timeline{
    //     const stopTl:TimelineMax = new TimelineMax({ 
    //         paused:true,
    //         onComplete:() =>  this.onSpinStopCompleted()
    //     });

    //     this.duration = 1;
    //     stopTl.add(() => this.callbacks.onStopCallback());
    //     for(var i = 0; i < this.Steps; i++){
    //         const durrSin:number = Sine.easeOut.getRatio(0.1 + Math.min(0.9, (this.duration/(this.Steps/i))/this.duration ) )
    //         const durr:number = this.duration * durrSin;
    //         console.log(durrSin);
    //         console.log(durr);
    //         stopTl.fromTo(this, durr, {yPos:0}, {
    //             ease : Linear.easeNone,
    //             yPos : this.stepDistance,
    //         });
    //         stopTl.add(() => this.callbacks.onCompletedStepCallback());
    //     }
        
    //     const e:any = CustomEase.create("nudge", "M0,0 C0,0 0.577,0.872 0.598,0.918 0.614,0.954 0.698,1.072 0.738,1.094 0.8,1.128 0.81,1.124 0.878,1.088 0.93,1.06 1,1 1,1")

    //     // this.duration = this.configDuration.STOP;
    //     // let ease:any = this.configEase.STOP;
        
    //     stopTl.fromTo(this, this.duration/this.Steps , {yPos: 0}, {
    //         ease : e,
    //         yPos : this.stepDistance,
    //     });
    //     stopTl.add(() => this.onBounce(),"-="+(this.duration*0.8));

    //     // Remove if we have created an normal stop first.
    //     delete this.nextTimeline;
    //     this.nextTimeline = stopTl;
    //     return this.nextTimeline;
    // }
}